import {Paper} from '@mui/material';
import {styled} from '@mui/styles';

const TableHolder = styled(Paper)(({theme}) => ({
  '&.MuiPaper-root': {
    margin: theme.spacing(2, 0, 0),
    overflow: 'hidden'
  }
}));

export default TableHolder;
